module.exports = __webpack_public_path__ + "img/register.02843609.png";